import React, { FC } from "react";
import Template from "../../templates/step4/Template";
import { IWizardStepContent } from "../../../../../wizard/types";

const Content: FC<IWizardStepContent> = ({ stepName, ...formData }) => (
  <Template stepName={stepName} formData={formData} />
);

export default Content;
